import React, {forwardRef, useImperativeHandle, useRef} from "react"

import Button, {ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";

type Props = {
    type        : ButtonType
    label       : string

    onSubmit?   : func
}

export default forwardRef(function Modal_Submit(props: Props, ref: any) {

    const selfRef   :any    = useRef()

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        setType: (type: ButtonType)=> {
            selfRef.current.setType(type)
        }
    }))

    const onSubmit = () => {
        selfRef.current.setType(ButtonType.BUSY)
        props.onSubmit?.()
    }

    return (
        <div className="flex-row-center-center flex-no-shrink h-90">
            <Button ref         = {selfRef}
                    className   = "min-w-150 p-h-8"
                    type        = {props.type}
                    label       = {props.label}
                    onClick     = {onSubmit}/>
        </div>
    )
})
